export enum DatadogActions {
  EmployerDetails = 2,
  PersonalDetails = 3,
  PackageDetails = 4,
  PaymentDetails = 5,
  SignUpComplete = 6,
  MembershipRegistrationComplete,
  LoginSignupStarted,
  LoginSignupCreateAccountClicked,
  LoginConfirmSignupClicked,
}
